export const PUBLIC_ROUTE = {
  LANDING: '/',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  FORGET_PASSWORD: '/forgotpassword',
  RESET_PASSWORD: '/resetpassword',
  SURVEY: '/survey/:id',
  PAGE_404: '/404',
  PAGE_500: '/500',
  AUTH0_CALLBACK: '/auth0loginCallback',
};

export const PRIVATE_ROUTE = {
  DASHBOARD: '/',
  DASHBOARD_ANALYTICS: '/analytics',
  TICKETS: '/tickets',
  // CONTACTS: '/contacts',
  COMPANIES: '/companies',
  USERS: '/users',
  TEMPLATES: '/templates',
  SURVEYS: '/surveys',
  EMAIL_CAMPAIGNS: '/email-campaigns',
};
